import Vue from "vue";
import Vuex from "vuex";
import restList from "./restListModules/rest-list-store";
import { Datepicker } from 'buefy';
import Toasted from "vue-toasted";

Vue.use(Datepicker);

Vue.use(Toasted, {
	theme: "toasted-primary",
	position: "top-right",
	duration: 5000
});


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

Vue.prototype.$CDN = CDN;

export default new Vuex.Store({
  modules: {
    restList,
    strict: debug
  }
});